import React from 'react'

class ModalLogs extends React.Component {

    state = {
        loading: false,
        datos: null,
    };

    dialogRef = React.createRef();

    componentDidUpdate(prevProps) {
        if (!prevProps.abierto && this.props.abierto) {
            const dialog = this.dialogRef.current;

            if (dialog && typeof dialog.showModal === "function") {
                requestAnimationFrame(() => {
                    dialog.showModal();
                });
            }
        }

        if (prevProps.abierto && !this.props.abierto) {
            this.dialogRef.current?.close();
        }
    }

    renderContenido = () => {
        const { loading, datos } = this.state;

        if (loading) return <p>Cargando...</p>;
        if (!datos) return <p>No se pudieron cargar los detalles.</p>;

        return this.props.renderContenido(datos);
    };

    handleCerrar = () => {
        this.dialogRef.current?.close();
        if (this.props.onClose) this.props.onClose();
    };

    render() {
        return (
            <div className="component-modal-side">
                <dialog
                    className="modal"
                    id="modal-logs"
                    ref={this.dialogRef}
                >
                    <div className="modal-content">
                        <div className="modal-head">
                            <h3 className="modal-title">Detalles de errores</h3>
                            <div className="actions">
                                <button
                                    className="btn-medium btn-circle-icon btn-primary-tonal"
                                    id="close-modal"
                                    onClick={this.handleCerrar}
                                >
                                    <span className="material-symbols-outlined">close</span>
                                </button>
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="scroll-content">
                                {this.props.errors.map((elemento, index) => (
                                    <div className="card" key={index}>
                                        <p className="txt">{elemento}.</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>


                </dialog>
            </div>
        )
    }
}

export default ModalLogs;
